import React from 'react'

import { useTransactionStore } from '../../../common'
import type { ActionBlockProps } from '../../mappings/blocks'

/**
 * Open-time data guarantee for the transaction-details drawer. Wired as the block's `usePrepare`,
 * so `ActionBlockLayer` runs it once each time a CTA opens the drawer (`ActionBlockRunner` mounts on
 * open and unmounts on close).
 *
 * A beat can be rendered in a feed long before the transactions module has ever loaded — the feed
 * does not depend on TransactionStore — so `detailedTransactions` is frequently empty at open time.
 * `loadTransactionData` also pulls the accounts and categories that `buildDetailedTransactions`
 * joins against, which is why it is preferred over the narrower `loadTransactions`.
 *
 * Guarded on `isTransactionDataLoaded` so re-opening the drawer does not refetch, and the store's
 * own in-flight flags make a concurrent call a no-op.
 */
export const useTransactionDetailsPrepare = (_props: ActionBlockProps) => {
  const { isTransactionDataLoaded, loadTransactionData } = useTransactionStore()

  React.useEffect(() => {
    if (!isTransactionDataLoaded) void loadTransactionData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
